export const DepartmentOptionKey = [
  "Accounting/Finance",
  "Blood Bank",
  "Clinical",
  "Customer Service",
  "Document Control",
  "EHS",
  "Engineering",
  "Executive (C-level or VP)",
  "Human Resources",
  "IT / Information Systems",
  "Laboratory",
  "Manufacturing",
  "Operations",
  "Other",
  "Packaging",
  "Product Development",
  "Purchasing",
  "Quality",
  "R&D",
  "R&D QA",
  "Regulatory",
  "Sales / Marketing",
  "Training",
  "Validation"
] as const;

export type DepartmentOptionKey = typeof DepartmentOptionKey[number];


export type DepartmentOptionsObject = {
  readonly [Key in  DepartmentOptionKey]: string
};